import React from 'react';
import { Grid, TextField } from '@mui/material';
import { QUESTION_TYPE } from '../../utils';

export default function Slider({ questionData, setQuestionData, selectedTab }) {
  return (
    (questionData.questionType === QUESTION_TYPE.NUMBER_SLIDER ||
      questionData.questionType === QUESTION_TYPE.PERCENTAGE) && (
      <div className='answer-options'>
        <Grid container columnSpacing={1.5} rowSpacing={1.5}>
          <Grid item xs={12} lg={12} md={12} sm={12} mb={1}>
            <div className='form-label'>Scale range label</div>
          </Grid>
          <Grid item xs={6} lg={6} md={6} sm={6}>
            <TextField
              size='small'
              fullWidth
              placeholder='From'
              type='number'
              value={questionData.sliderResponseAttributes?.rangeFrom}
              onChange={(e) =>
                setQuestionData({
                  ...questionData,
                  sliderResponseAttributes: {
                    ...questionData.sliderResponseAttributes,
                    rangeFrom: parseInt(e.target.value),
                  },
                })
              }
            />
          </Grid>
          <Grid item xs={6} lg={6} md={6} sm={6}>
            <TextField
              size='small'
              fullWidth
              placeholder='To'
              type='number'
              value={questionData.sliderResponseAttributes?.rangeTo}
              onChange={(e) =>
                setQuestionData({
                  ...questionData,
                  sliderResponseAttributes: {
                    ...questionData.sliderResponseAttributes,
                    rangeTo: parseInt(e.target.value),
                  },
                })
              }
            />
          </Grid>
          <Grid item xs={12} lg={12} md={12} sm={12}>
            <TextField
              size='small'
              fullWidth
              placeholder='High label'
              value={
                questionData.sliderResponseAttributes?.[
                  selectedTab === 1
                    ? 'staffHighScaleLabel'
                    : selectedTab === 2
                    ? 'parentHighScaleLabel'
                    : 'pupilHighScaleLabel'
                ]
              }
              onChange={(e) =>
                setQuestionData({
                  ...questionData,
                  sliderResponseAttributes: {
                    ...questionData.sliderResponseAttributes,
                    [selectedTab === 1
                      ? 'staffHighScaleLabel'
                      : selectedTab === 2
                      ? 'parentHighScaleLabel'
                      : 'pupilHighScaleLabel']: e.target.value,
                  },
                })
              }
            />
          </Grid>

          <Grid item xs={12} lg={12} md={12} sm={12}>
            <TextField
              size='small'
              fullWidth
              placeholder='Middle label'
              value={
                questionData.sliderResponseAttributes?.[
                  selectedTab === 1
                    ? 'staffMidScaleLabel'
                    : selectedTab === 2
                    ? 'parentMidScaleLabel'
                    : 'pupilMidScaleLabel'
                ]
              }
              onChange={(e) =>
                setQuestionData({
                  ...questionData,
                  sliderResponseAttributes: {
                    ...questionData.sliderResponseAttributes,
                    [selectedTab === 1
                      ? 'staffMidScaleLabel'
                      : selectedTab === 2
                      ? 'parentMidScaleLabel'
                      : 'pupilMidScaleLabel']: e.target.value,
                  },
                })
              }
            />
          </Grid>

          <Grid item xs={12} lg={12} md={12} sm={12}>
            <TextField
              size='small'
              fullWidth
              placeholder='Low label'
              value={
                questionData.sliderResponseAttributes?.[
                  selectedTab === 1
                    ? 'staffLowScaleLabel'
                    : selectedTab === 2
                    ? 'parentLowScaleLabel'
                    : 'pupilLowScaleLabel'
                ]
              }
              onChange={(e) =>
                setQuestionData({
                  ...questionData,
                  sliderResponseAttributes: {
                    ...questionData.sliderResponseAttributes,
                    [selectedTab === 1
                      ? 'staffLowScaleLabel'
                      : selectedTab === 2
                      ? 'parentLowScaleLabel'
                      : 'pupilLowScaleLabel']: e.target.value,
                  },
                })
              }
            />
          </Grid>
        </Grid>
      </div>
    )
  );
}
